import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 20px 10px;
`;

export const BoxUser = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 80px;
  color: var(--grey-7);
  border-bottom: 1px solid var(--grey-3);
`;

export const UserName = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: 2px;
`;
